<template>
    <div class="nc-guided-field">
        <v-textarea
            ref="textarea"
            :value="value"
            :label="label"
            :error-messages="errorMessages"
            outlined
            dense
            auto-grow
            rows="2"
            hide-details="auto"
            @input="$emit('input', $event)"
        ></v-textarea>
        <p class="nc-guide text--secondary t-caption">{{ guide }}</p>
        <p v-if="example" class="nc-example text--secondary t-caption">{{ example }}</p>
        <div>
            <v-chip
                v-for="suggestion in suggestions"
                :key="suggestion"
                small
                outlined
                class="mr-1 mb-1"
                @click="chooseSuggestion(suggestion)"
            >
                {{ suggestion }}
            </v-chip>
        </div>
        <v-dialog v-model="replaceDialog" max-width="520">
            <v-card class="mc-root mc-dialog nc-mecom nc-confirm">
                <v-card-title>Sostituire il testo?</v-card-title>
                <v-card-text>
                    Il campo contiene già del testo. Confermare la sostituzione con il suggerimento selezionato.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="replaceDialog = false">Annulla</v-btn>
                    <v-btn depressed color="primary" @click="replaceText">Sostituisci</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "NcGuidedTextarea",
    props: {
        value: { type: String, default: "" },
        label: { type: String, required: true },
        guide: { type: String, required: true },
        example: { type: String, required: true },
        suggestions: { type: Array, default: () => [] },
        errorMessages: { type: Array, default: () => [] },
    },
    data: () => ({
        replaceDialog: false,
        pendingSuggestion: "",
    }),
    methods: {
        focus() {
            const input = this.$refs.textarea;
            if (input && typeof input.focus === "function") input.focus();
        },
        chooseSuggestion(suggestion) {
            if (!String(this.value || "").trim()) {
                this.$emit("input", suggestion);
                return;
            }
            this.pendingSuggestion = suggestion;
            this.replaceDialog = true;
        },
        replaceText() {
            this.$emit("input", this.pendingSuggestion);
            this.replaceDialog = false;
            this.pendingSuggestion = "";
        },
    },
};
</script>

<style scoped>
.nc-guide {
    margin-top: var(--space-2);
    margin-bottom: var(--space-2);
    color: var(--ink-2) !important;
}

.nc-example {
    color: var(--ink-2) !important;
    font-style: italic;
}
.nc-guided-field { margin-bottom: var(--space-5); }
.nc-guided-field ::v-deep .v-chip { min-height: var(--touch-target); height: auto; }
.nc-guided-field ::v-deep .v-chip__content { white-space: normal; padding: var(--space-2) 0; }
</style>
